import { Group, Line, Rect, Circle, Text } from "react-konva";
import { api } from "../../../lib/api";

// GM-only: placed wall segments + their floating delete button, plus the three live draft-preview
// lines (wall-in-progress, cone/line template-in-progress, trigger-line-in-progress). Extracted
// verbatim from MapCanvas.jsx (Phase 42 refactor) — no behavior changes.
export function MapWallsLayer({ game, walls, selectedWallId, setSelectedWallId, activeTool, handleOverlayClick, wallDraft, templateDraft, triggerLineDraft }) {
  return (
    <>
      {(walls || []).map((w) => (
        <Group
          key={w.id}
          draggable={!activeTool}
          onDragEnd={async (e) => {
            const dx = e.target.x(), dy = e.target.y();
            e.target.position({ x: 0, y: 0 });
            await api.patch(`/games/${game.id}/walls/${w.id}`, { x1: w.x1 + dx, y1: w.y1 + dy, x2: w.x2 + dx, y2: w.y2 + dy });
          }}
          onClick={(e) => {
            if (handleOverlayClick(e)) return;
            e.cancelBubble = true;
            setSelectedWallId(selectedWallId === w.id ? null : w.id);
          }}
          onTap={(e) => {
            if (handleOverlayClick(e)) return;
            e.cancelBubble = true;
            setSelectedWallId(selectedWallId === w.id ? null : w.id);
          }}
        >
          <Line
            data-testid={`wall-line-${w.id}`}
            points={[w.x1, w.y1, w.x2, w.y2]}
            stroke={selectedWallId === w.id ? "#D4AF37" : "#7dd3fc"}
            strokeWidth={selectedWallId === w.id ? 5 : 3}
            hitStrokeWidth={16}
            lineCap="round"
          />
        </Group>
      ))}
      {selectedWallId && (() => {
        const w = (walls || []).find((ww) => ww.id === selectedWallId);
        if (!w) return null;
        return (
          <Group
            key={`wall-actions-${w.id}`}
            x={(w.x1 + w.x2) / 2 - 13}
            y={(w.y1 + w.y2) / 2 - 34}
            data-testid={`wall-delete-${w.id}`}
            onClick={async (e) => {
              e.cancelBubble = true;
              if (!window.confirm("Delete this wall segment? This can't be undone.")) return;
              await api.delete(`/games/${game.id}/walls/${w.id}`);
              setSelectedWallId(null);
            }}
            onTap={async (e) => {
              e.cancelBubble = true;
              if (!window.confirm("Delete this wall segment? This can't be undone.")) return;
              await api.delete(`/games/${game.id}/walls/${w.id}`);
              setSelectedWallId(null);
            }}
          >
            <Rect width={26} height={24} cornerRadius={12} fill="#322216dd" stroke="#D90429" strokeWidth={1} />
            <Text text="X" width={26} height={24} align="center" verticalAlign="middle" fontSize={12} fill="#D90429" fontStyle="bold" />
          </Group>
        );
      })()}
      {wallDraft && (
        <Line points={[wallDraft.start.x, wallDraft.start.y, wallDraft.end.x, wallDraft.end.y]} stroke="#7dd3fc" strokeWidth={3} dash={[10, 6]} lineCap="round" listening={false} />
      )}
      {templateDraft && (
        <Line points={[templateDraft.start.x, templateDraft.start.y, templateDraft.end.x, templateDraft.end.y]} stroke="#D90429" strokeWidth={4} dash={[8, 6]} lineCap="round" listening={false} />
      )}
      {triggerLineDraft && (
        <>
          <Line
            points={[...triggerLineDraft.points.flatMap((p) => [p.x, p.y]), triggerLineDraft.preview.x, triggerLineDraft.preview.y]}
            stroke="#D4AF37" strokeWidth={3} dash={[10, 6]} lineCap="round" listening={false}
          />
          {triggerLineDraft.points.map((p, i) => (
            <Circle key={`trigger-draft-pt-${i}`} x={p.x} y={p.y} radius={4} fill="#D4AF37" listening={false} />
          ))}
        </>
      )}
    </>
  );
}
